export enum AtencionPreferencialEnum {
    Discapacidad = 3,
    GrupoEtnico = 8
}